<div class="justup-dialog-search">
  <label for="input-search">
    <mat-icon class="px-12 cursor-pointer">search</mat-icon>
  </label>
  <input autocomplete="off" (click)="onClick()" [(ngModel)]="search" id="input-search" class="grow justup-dialog-input"
         type="text" [placeholder]="'input_search_dialog.placeholder' | trans">
  <mat-icon (click)="onClose()" class="px-12 cursor-pointer">close</mat-icon>
</div>
